import Cookie from 'js-cookie';

/**
 * Get the Ticketbis event url, fix the hostname to which the event belongs to
 * @param {Object} event
 * @param {String} targetBaseUrl https://intl.stubhub.com/
 * @param {String} defaultWebTLD web TLD to use for affiliate part of the URL
 * @return {String} url //event url
 */
export default (event = {}, targetBaseUrl = '', defaultWebTLD = '') => {
  const externalWebURI = event.attributes ? event.attributes.externalWebURI : event.externalWebURI;

  let affiliateData = Cookie.get('tb_affl');
  let tbTrackUrl = '';
  const campaignToken = '1Q606O8YRW';
  if (affiliateData) {
    affiliateData = affiliateData.split('-');
    const [source] = affiliateData;
    const campaign = affiliateData.length > 1 && affiliateData[1];
    tbTrackUrl = `?afl=${campaignToken}&utm_medium=affiliate&utm_campaign=${campaign}&utm_source=${source}`;
  } else if (defaultWebTLD) {
    tbTrackUrl = `?afl=${campaignToken}&utm_medium=referral&utm_campaign=${event.id}&utm_source=sh-${defaultWebTLD}`;
  }
  // Concatenating the URIs and ensuring only one trailing slash
  const ticketBisEventUrl = `${targetBaseUrl}/${externalWebURI}${tbTrackUrl}`.replace(/(https?:\/\/)|(\/)+/g, '$1$2');

  return ticketBisEventUrl;
};
